import { render, staticRenderFns } from "./add-certificate.vue?vue&type=template&id=000cb1ba&scoped=true&"
import script from "./add-certificate.vue?vue&type=script&lang=js&"
export * from "./add-certificate.vue?vue&type=script&lang=js&"
import style0 from "./add-certificate.vue?vue&type=style&index=0&id=000cb1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000cb1ba",
  null
  
)

export default component.exports